import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

export default function CardIcon(props) {
  let styles = false;
  if(Array.isArray(props.styles)) {
    styles = css`${props.styles[0]}`;
  }
  return <span className={`card-icon ${styles} ${props.cardType}`} />;
}

CardIcon.propTypes = {
  styles: PropTypes.oneOfType([
    PropTypes.arrayOf(Object),
    PropTypes.bool
  ]),
  cardType: PropTypes.string,
};
